import BaseService from './baseService'; 



export class ChangePrincipleService extends BaseService {
    constructor(){
        const baseUrl = "/Persons/Principal/";
        super(baseUrl);
    }  
} 